import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import {
  postPreparationGuide,
  updatePreparationGuide,
  deletePreparationGuide,
} from '../../http/doctorAPI';

const PreparationsGuide = ({
  specializationId,
  specializationServiceId,
  open,
  onClose,
  onGuideCreated,
  onGuideDeleted,
  preparationGuide,
}) => {
  const [name, setName] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    if (open) {
      if (preparationGuide) {
        setName(preparationGuide.name);
        setContent(preparationGuide.content);
      } else {
        setName('');
        setContent('');
      }
    }
  }, [open, preparationGuide]);

  const handleSubmit = () => {
    if (!name.trim() || !content.trim()) {
      alert('Пожалуйста, заполните название и содержимое памятки');
      return;
    }

    const guideData = {
      id: preparationGuide ? preparationGuide.id : undefined,
      name,
      content,
      specializationId: specializationServiceId ? undefined : specializationId,
      specializationServiceId,
    };

    const apiCall = preparationGuide
      ? updatePreparationGuide(guideData) // Передаем id для обновления
      : postPreparationGuide(guideData);

    apiCall.then((data) => {
      if (!data.error) {
        onGuideCreated(data);
        onClose();
      }
    });
  };

  const handleDelete = () => {
    if (preparationGuide && preparationGuide.id) {
      deletePreparationGuide(preparationGuide.id).then((data) => {
        if (!data.error) {
          onGuideDeleted();
          onClose();
        }
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{preparationGuide ? 'Редактировать памятку' : 'Создать памятку'}</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <TextField
            autoFocus
            margin='dense'
            label='Название памятки'
            type='templateText'
            fullWidth
            variant='outlined'
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Box>
        <Box>
          <TextField
            margin='dense'
            label='Содержимое памятки'
            type='templateText'
            fullWidth
            variant='outlined'
            multiline
            rows={4}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit}
          disabled={!name.trim() || !content.trim()}
          variant='contained'
          >
          {preparationGuide ? 'Сохранить' : 'Создать'}
        </Button>
          {preparationGuide && (
            <Button onClick={handleDelete} color='error'>
              Удалить памятку
            </Button>
          )}
          <Button onClick={onClose}>Отмена</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreparationsGuide;
